export default function SVG_Scripting() {
  return (
    <div>
      <h1>SVG_Scripting Component</h1>
    </div>
  );
}
